import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const telegramUserSchema = z.object({
  userId: z.string(),
  name: z.string(),
  email: z.string(),
  image: z.string().nullable(),
  telegramId: z.string(),
  joinedAt: z.string(),
});

const telegramAdminUsersDataSchema = z.object({
  users: z.array(telegramUserSchema),
  nextCursor: z.string().nullable(),
});

export type ITelegramAdminUser = z.infer<typeof telegramUserSchema>;
export type ITelegramAdminUsersData = z.infer<typeof telegramAdminUsersDataSchema>;

export const telegramAdminUsersResponseSchema = createApiResponseSchema(
  telegramAdminUsersDataSchema,
) as z.ZodSchema<IAPI<ITelegramAdminUsersData>>;

export type ITelegramAdminUsersResponse = IAPI<ITelegramAdminUsersData>;
